module.exports = __webpack_public_path__ + "img/example_event.3be86962.jpg";